// utils/images.ts

/**
 * Returns a safe image URL for use in <Image /> components.
 * - Falls back to /assets/OfferCodeFlight.jpg if url is missing, empty, 'undefined', or invalid.
 * - If url looks like a MongoDB ObjectId or just a filename, prefixes with /uploads/.
 * - If url is not absolute and doesn't start with '/', prefixes with /uploads/.
 * - Otherwise returns the url as-is.
 *
 * @param url Image URL, ObjectId, or filename
 * @returns Safe image URL string
 */
export function getSafeImageUrl(url?: string): string {
  const FALLBACK = '/assets/OfferCodeFlight.jpg';
  if (!url || typeof url !== 'string' || url.trim() === '' || url.includes('undefined')) return FALLBACK;
  // // If url looks like a MongoDB ObjectId (24 hex chars)
  // if (/^[a-f\d]{24}$/i.test(url)) return `/uploads/${url}`;
  // // If url is just a filename (no slashes or protocol)
  // if (!url.startsWith('/') && !/^https?:\/\//.test(url)) return `/uploads/${url}`;
  // // If url is absolute or already a valid path
  return url;
}
